export default __webpack_public_path__ + "static/essay-ddfd4ac927a9cfe394e3c2f3a63bf84d.svg";